var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.864C5.65202 10.9517 5.82446 10.9979 6 10.9979C6.17554 10.9979 6.34798 10.9517 6.5 10.864L10 8.86397C10.1519 8.77629 10.278 8.65022 10.3658 8.49839C10.4535 8.34657 10.4998 8.17434 10.5 7.99897V3.99897C10.4998 3.82361 10.4535 3.65138 10.3658 3.49956C10.278 3.34773 10.1519 3.22166 10 3.13397L6.5 1.13397C6.34798 1.04621 6.17554 1 6 1C5.82446 1 5.65202 1.04621 5.5 1.13397L2 3.13397C1.84813 3.22166 1.72199 3.34773 1.63423 3.49956C1.54647 3.65138 1.50018 3.82361 1.5 3.99897V7.99897C1.50018 8.17434 1.54647 8.34657 1.63423 8.49839C1.72199 8.65022 1.84813 8.77629 2 8.86397L5.5 10.864Z",
    stroke: "#314158",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11V6",
    stroke: "#314158",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64502 3.5L6.00002 6L10.355 3.5",
    stroke: "#314158",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.13672L8.25 4.71172",
    stroke: "#314158",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.076b2176fb9375a99d57fb43e6b62b6a.svg";
export { ForwardRef as ReactComponent };